import { CalendarDays } from 'lucide-react';
import { Panel, Metric, Empty } from './Panel';

export const ScheduleCard = ({ s }) => {
  const m = s.summary;
  return (
    <Panel title="This week's schedule health" subtitle={`Week of ${s.week_start}`} icon={CalendarDays} to="/ludo/schedule" linkLabel="Open scheduling" testid="ludo-dash-schedule">
      <div className="grid grid-cols-2 gap-3 mb-5">
        <Metric label="Sessions booked" value={m.sessions} sub={`${m.covered} covered`} testid="ludo-dash-sched-sessions" />
        <Metric label="Uncovered hours" value={m.uncovered_hours} tone={m.uncovered_hours ? 'text-[#8A3A3A]' : 'text-[#3C6152]'} testid="ludo-dash-sched-uncovered" />
        <Metric label="Direct hours covered" value={m.direct_hours} testid="ludo-dash-sched-direct" />
        <Metric label="Clients under auth hrs" value={s.clients_short} tone={s.clients_short ? 'text-[#B08A3A]' : undefined} testid="ludo-dash-sched-short" />
      </div>
      <div className="space-y-3 mb-5" data-testid="ludo-dash-utilization">
        {s.utilization.length === 0 ? <Empty>No BTs or BCBAs added to scheduling yet.</Empty> : s.utilization.map((u) => (
          <div key={u.group} data-testid={`ludo-dash-util-${u.group.toLowerCase()}`}>
            <div className="flex justify-between text-[12.5px]">
              <span className="font-semibold text-[#2D2833]">{u.group === 'BT' ? 'BTs / RBTs' : 'BCBAs'} <span className="text-[#8A7B95] font-normal">· {u.count}</span></span>
              <span className="tabular-nums text-[#6E5F78]">{u.scheduled} / {u.capacity} hrs · {u.pct}%</span>
            </div>
            <div className="h-2.5 rounded-full bg-[#F1EDF5] mt-1 overflow-hidden">
              <div className={`h-full rounded-full ${u.pct > 100 ? 'bg-[#8A3A3A]' : 'bg-[#5E5068]'}`} style={{ width: `${Math.min(100, u.pct)}%` }} />
            </div>
            <div className="text-[11px] text-[#8A7B95] mt-0.5">{u.free} free hrs available this week</div>
          </div>
        ))}
      </div>
      <div className="text-[11px] uppercase tracking-[0.12em] text-[#8A3A3A] font-semibold mb-2">Gaps · {m.gaps}</div>
      {s.gaps.length === 0 ? <Empty testid="ludo-dash-gaps-empty">No coverage gaps this week.</Empty> : (
        <ul className="space-y-1.5" data-testid="ludo-dash-gaps">
          {s.gaps.map((g, i) => (
            <li key={i} className="text-[12.5px] text-[#2D2833]">
              <span className="font-semibold">{g.client_name}</span>
              {g.date && <span className="text-[#8A7B95]"> · {g.date} {g.start}–{g.end}</span>}
              <span className="text-[#8A3A3A]"> — {g.issues.join('; ')}</span>
            </li>
          ))}
        </ul>
      )}
    </Panel>
  );
};

export default ScheduleCard;
